import React, { forwardRef } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment/moment';

const Field = ({ label, value, color }) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
        <Typography
            sx={{
                fontSize: '11px',
                color: '#8a8b8c',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
            }}
        >
            {label}
        </Typography>
        <Typography
            sx={{
                fontSize: '13px',
                color: color || '#245372',
                fontWeight: 500
            }}
        >
            {value || '—'}
        </Typography>
    </Box>
);

const Section = ({ title }) => (
    <Box sx={{ gridColumn: '1 / -1' }}>
        <Typography
            sx={{
                fontSize: '11px',
                fontWeight: 700,
                color: '#245372',
                textTransform: 'uppercase',
                letterSpacing: '0.8px',
                mb: '6px'
            }}
        >
            {title}
        </Typography>
        <Divider sx={{ borderColor: '#3DC3C1', mb: '12px' }} />
    </Box>
);

const getTypeColor = (type) =>
    type === 'sell' ? 'rgba(235, 105, 105, 1)' : 'rgba(39, 169, 255, 1)';

const getUnit = (deliverypoint) =>
    deliverypoint === 'PEG' ? 'MWh/day' : 'MWh/h';

const OrderLogDetail = forwardRef(({ handleClose, order }, ref) => {
    if (!order) return null;

    const {
        data,
        order_price_str,
        order_status,
        username,
        created_at,
        contract_date_from_cet,
        contract_date_to_cet,
        uuid
    } = order;

    return (
        <Box className="modal-container" ref={ref} sx={{ minWidth: '560px' }}>
            <Box
                className="flex justify-between modal-header"
                sx={{ alignItems: 'center' }}
            >
                <h2 className="modal-title">Order Details</h2>
                <CloseIcon
                    className="cursor-pointer"
                    onClick={handleClose}
                    sx={{ color: '#245372' }}
                />
            </Box>
            <Box className="modal-body">
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '16px'
                    }}
                >
                    {uuid && (
                        <>
                            <Section title="Reference" />
                            <Box sx={{ gridColumn: '1 / -1' }}>
                                <Field label="UUID" value={uuid} />
                            </Box>
                        </>
                    )}
                    <Section title="Contract Info" />
                    <Field label="Contract" value={data?.sym} color="#3B9D9D" />
                    <Field label="Delivery Point" value={data?.deliverypoint} />
                    <Field
                        label="Unit"
                        value={getUnit(data?.deliverypoint)}
                        color="#27A9FF"
                    />
                    <Field
                        label="Type"
                        value={data?.type === 'sell' ? 'Sell' : 'Buy'}
                        color={getTypeColor(data?.type)}
                    />

                    <Section title="Parties" />
                    <Field label="Buyer" value={data?.buyer} />
                    <Field label="Seller" value={data?.seller} />
                    <Field label="Account" value={username} />

                    <Section title="Financials" />
                    <Field label="Volume" value={data?.volume} />
                    <Field label="Price" value={order_price_str} />
                    <Field label="Currency" value={data?.currency} />
                    <Field label="Status" value={order_status || 'Completed'} />

                    <Section title="Dates" />
                    <Field
                        label="Created At"
                        value={
                            created_at
                                ? moment(created_at).format(
                                      'YYYY-MM-DD HH:mm:ss'
                                  )
                                : null
                        }
                    />
                    <Field
                        label="Delivery Start"
                        value={
                            contract_date_from_cet
                            // ? moment(contract_date_from_cet).format(
                            //       'YYYY-MM-DD HH:mm:ss'
                            //   )
                            // : null
                        }
                    />
                    <Field
                        label="Delivery End"
                        value={
                            contract_date_to_cet
                            // ? moment(contract_date_to_cet).format(
                            //       'YYYY-MM-DD HH:mm:ss'
                            //   )
                            // : null
                        }
                    />
                </Box>
            </Box>
            <Box className="modal-footer">
                <button
                    className="modal-button-secondary"
                    onClick={handleClose}
                >
                    Close
                </button>
            </Box>
        </Box>
    );
});

export default OrderLogDetail;
